import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const getMileStoneTable = async (testSuiteResultId) => {
  const user = getUserDetails();

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getMileStoneTableForTestSuiteResult&companyid=${user.companyid}&testSuiteResultId=${testSuiteResultId}`,
  );

  const data = response.data;
  return Array.isArray(data) ? data : [];
};

const useGetMileStoneTableQuery = (testSuiteResultId, options) => {
  return useQuery({
    queryKey: ["mileStoneTable", testSuiteResultId],
    queryFn: () => getMileStoneTable(testSuiteResultId),
    enabled: options.enabled,
    ...options,
  });
};

export default useGetMileStoneTableQuery;
